import Head from 'next/head';
import { ReactElement } from 'react';
import { createStructuredBlogData } from '@/entities/Activity/app/Creators';
import { TPageContent } from '@/entities/Content/ui/Content.types';

type MetaBlogsDetailsProps = {
    pageContent: TPageContent;
    image: string;
    rootUrl?: string;
};

const MetaBlogsDetails = ({ pageContent, image, rootUrl }: MetaBlogsDetailsProps): ReactElement => {
    return (
        <Head>
            <title>{pageContent.title}</title>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: createStructuredBlogData(pageContent) }}
            />
            <meta name="description" key="description" content={pageContent.description} />
            <meta property="og:url" content={rootUrl} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={pageContent.title} />
            <meta property="og:image:alt" content={pageContent.title} />
            <meta property="og:description" content={pageContent.description} />
            <meta property="og:image" content={image} />
            {/* <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@tripshock" /> */}
            <link rel="canonical" key="canonical" href={rootUrl} />
        </Head>
    );
};

export { MetaBlogsDetails };
export default MetaBlogsDetails;
